import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CreatorCard from '../components/CreatorCard';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

// Same category list as SubmitForm
const availableCategories = [
  "Audio Books",
  "Automotive/EVs",
  "Books",
  "Charity/Fundraising",
  "Coders/Web Developers",
  "Collectibles",
  "Comics",
  "Consulting",
  "Cosplay",
  "Courses/Tutorials",
  "Craftwork",
  "Digital Backgrounds",
  "Ebooks",
  "EZines",
  "Finance/Investing",
  "Gaming",
  "Illustration",
  "Music",
  "NFT Art",
  "Photography",
  "Podcasting",
  "Printables",
  "Stationery",
  "Stickers",
  "Streamers",
  "Video Creation",
  "Vlogging",
  "Virtual Assistants",
  "Writing/Blogging",
].sort();

function Creators() {
  const [creators, setCreators] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [allCreators, setAllCreators] = useState([]);
  const [skip, setSkip] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('');

  const fetchCreators = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE}/submissions?type=creator&limit=500`);
      setCreators(res.data.slice(0, 25));
      setAllCreators(res.data);
    } catch (err) {
      alert('Failed to load creators');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchCreators();
  }, []);

  const handleLoadMore = () => {
    const newSkip = skip + 25;
    setSkip(newSkip);
    const nextCreators = allCreators.slice(0, newSkip + 25);
    setCreators(nextCreators);
  };

  const filterByCategory = (category) => {
    setSelectedCategory(category);
    setSkip(0);

    if (category === '') {
      setCreators(allCreators.slice(0, 25));
    } else {
      const filtered = allCreators.filter(sub => 
        sub.categories && sub.categories.includes(category)
      );
      setCreators(filtered.slice(0, 25));
    }
  };

  // 🔍 SEARCH FILTER LOGIC - INSERTED HERE
  const filteredCreators = creators.filter(sub =>
    sub.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    sub.description?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div style={{ maxWidth: '1100px', margin: '30px auto', padding: '20px', fontFamily: "'Nunito', sans-serif" }}>
      <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>All Creator Submissions</h2>

      {/* Category Filter Buttons */}
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        justifyContent: 'center',
        marginBottom: '20px'
      }}>
        {availableCategories.map(cat => (
          <button
            key={cat}
            onClick={() => filterByCategory(cat)}
            style={{
              padding: '6px 12px',
              backgroundColor: selectedCategory === cat ? '#4dabf7' : '#e3f2fd',
              color: '#333',
              border: 'none',
              borderRadius: '20px',
              cursor: 'pointer',
              fontSize: '0.85rem',
              fontWeight: 'bold',
              transition: 'background 0.2s',
            }}
          >
            {cat}
          </button>
        ))}

        {selectedCategory && (
          <button
            onClick={() => filterByCategory('')}
            style={{
              padding: '6px 12px',
              backgroundColor: '#ff6961',
              color: 'white',
              border: 'none',
              borderRadius: '20px',
              cursor: 'pointer',
              fontSize: '0.85rem',
              fontWeight: 'bold',
              transition: 'background 0.2s',
            }}
          >
            Clear Filter
          </button>
        )}
      </div>

      {/* 🔎 Search Box */}
      <div style={{ textAlign: 'center', marginBottom: '30px' }}>
        <input
          type="text"
          placeholder="Search creators..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          style={{
            width: '100%',
            maxWidth: '400px',
            padding: '10px 14px',
            fontSize: '1rem',
            border: '1px solid #ddd',
            borderRadius: '8px',
            outline: 'none',
          }}
        />
      </div>

      {/* Creator Cards */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '20px'
      }}>
        {loading ? (
          <p style={{ textAlign: 'center' }}>Loading...</p>
        ) : filteredCreators.length > 0 ? (
          filteredCreators.map(sub => (
            <CreatorCard key={sub._id} submission={sub} />
          ))
        ) : (
          <p style={{ textAlign: 'center' }}>No creators found.</p>
        )}
      </div>

      {/* Load More Button */}
      {selectedCategory === '' && creators.length > 0 && creators.length % 25 === 0 && (
        <div style={{ textAlign: 'center', marginTop: '30px' }}>
          <button
            onClick={handleLoadMore}
            disabled={loading}
            style={{
              padding: '10px 20px',
              borderRadius: '20px',
              backgroundColor: '#4dabf7',
              color: '#fff',
              fontSize: '1rem',
              border: 'none',
              cursor: 'pointer'
            }}
          >
            {loading ? 'Loading...' : 'See next set >>'}
          </button>
        </div>
      )}

      {/* End of List Message */}
      {selectedCategory === '' && creators.length > 0 && creators.length % 25 !== 0 && (
        <p style={{ textAlign: 'center', marginTop: '30px', fontSize: '1rem', color: '#555' }}>
          🎉 You've reached the end!
        </p>
      )}
    </div>
  );
}

export default Creators;